import { includes } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import ChatPanel from './ChatPanel';
import ConversationFilter from './ConversationFilter';
import ConversationList from './ConversationList';
import SendingAs from './SendingAs';
import { ConversationsProvider } from '../../contexts/ConversationsContext';
import { useConversationsContext } from '../../contexts/ConversationsContext';

const parseGroupFilters = (selectedOptions) => {
  const groupIds = [];
  const subgroupIds = [];
  const cohortIds = [];

  (selectedOptions || []).forEach(({ value }) => {
    const [type, id] = value.split('_');
    if (type === 'group') groupIds.push(id);
    else if (type === 'subgroup') subgroupIds.push(id);
    else if (type === 'cohort') cohortIds.push(id);
  });

  return { groupIds, subgroupIds, cohortIds };
};

const IndividualMessages = ({
  auth,
  filtersForGroups,
  filtersForGroupsReady,
}) => {
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const selectedConversationId = searchParams.get('id') || null;

  // The UNREAD tab is driven by the URL so it can be deep-linked into — both by the
  // nav bell and by the daily unread-messages email.
  const unreadOnly = searchParams.get('filter') === 'unread';
  const [searchQuery, setSearchQuery] = useState('');
  const [groupFilters, setGroupFilters] = useState({ groupIds: [], subgroupIds: [], cohortIds: [] });

  const handleFilterChange = (value) => {
    const params = new URLSearchParams(location.search);
    if (value) params.set('filter', 'unread');
    else params.delete('filter');

    history.replace({ pathname: location.pathname, search: params.toString() });
  };
  const handleSearchChange = (query) => setSearchQuery(query);
  const handleGroupFilterChange = (selected) => setGroupFilters(parseGroupFilters(selected || []));

  return (
    <ConversationsProvider selectedConversationId={selectedConversationId}>
      <SendingAs/>
      <div className="o-communication__individuals-layout">
        <div className="o-communication__sidebar">
          <ConversationFilter
            unreadOnly={unreadOnly}
            onSearchChange={handleSearchChange}
            onFilterChange={handleFilterChange}
            onGroupFilterChange={handleGroupFilterChange}
            filtersForGroups={filtersForGroups}
            filtersForGroupsReady={filtersForGroupsReady}
          />
          <ConversationList
            unreadOnly={unreadOnly}
            searchQuery={searchQuery}
            groupFilters={groupFilters}
            isASQEnabledForPartner={includes(auth.options, 'asqEnabled')}
          />
        </div>
        <ChatPanel
          auth={auth}
          authorId={parseInt(auth.id)}
        />
      </div>
    </ConversationsProvider>
  );
};

IndividualMessages.propTypes = {
  auth: PropTypes.object.isRequired,
  filtersForGroups: PropTypes.object,
  filtersForGroupsReady: PropTypes.bool,
};

const mapStateToProps = state => {
  const filters = state.communicationFilters?.filtersForGroups;
  const loaded = filters?.loaded;
  const isLoading = filters?.isLoading;

  return {
    auth: state.auth,
    filtersForGroups: filters?.filters || {},
    filtersForGroupsReady: loaded && !isLoading,
  };
};

export default connect(mapStateToProps, {})(IndividualMessages);
